import { render, staticRenderFns } from "./IrrigationUpkeeps.vue?vue&type=template&id=5ad5976c&scoped=true&lang=html&"
import script from "./IrrigationUpkeeps.vue?vue&type=script&lang=js&"
export * from "./IrrigationUpkeeps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad5976c",
  null
  
)

export default component.exports